export enum NoteTypeKeyEnum {
  ParcelSplitPreApproveByBuildingAuthority = 'ParcelSplitPreApproveByBuildingAuthority',
  ParcelSplitPreApproveByOwner = 'ParcelSplitPreApproveByOwner',
  ConceptDisapprovedReason = 'ConceptDisapprovedReason',
  ImportDataRequested = 'ImportDataRequested',
  ImportDataReceived = 'ImportDataReceived',
}
